module.exports = __webpack_public_path__ + "img/envelope.1d61a504.svg";